module.exports = __webpack_public_path__ + "img/UK-Scotland.96f80702.png";